import React from 'react';

import InactiveCpInfo from './RebarInactiveCpInfo';

import CpInfoHeader from './RebarCpInfoHeader';
import BackgroundCpInfo from './RebarBackgroundCpInfo';
import RebarActiveCpInfo from './RebarActiveCpInfo';
import useRebarCpInfoNew from '../../../hooks/useCpInfo/useRebarCpInfoNew';
import { checkProjectActivationOrPermission } from '../../../other/utilFunctions';

const RebarCpInfo = ({
    id,
    result,
    projectUnitPrice,
    unitDiscount,
    unitPriceType,
    purchasable,
    userType,
    ownCp,
    owner,
    backgroundTask
}) => {

    const {
        isComponentLoading
    } = useRebarCpInfoNew(result, userType);

    let CpInfoContainer;

    if (isComponentLoading) {
        CpInfoContainer = <></>
    }
    else {
        const CpHeader = (
            <div className='mx-2'>
                <CpInfoHeader
                    id={id}

                    userType={userType}
                    activated={result.activated}
                    backgroundTask={backgroundTask}
                    ownCp={ownCp}
                    owner={owner}
                    result={result}
                />
            </div>
        )
        if (backgroundTask) {
            CpInfoContainer = <>
                {CpHeader}
                <BackgroundCpInfo
                    userType={userType}
                    ownCp={ownCp}
                    owner={owner}
                    result={result}
                />
            </>
        }
        else {
            const activationOrPermission = checkProjectActivationOrPermission(result.activated, result.cuttingPlanPermission);
            if (activationOrPermission) {
                CpInfoContainer = <>
                    {CpHeader}
                    <RebarActiveCpInfo />
                </>
            }
            else {
                CpInfoContainer = <>
                    {CpHeader}
                    <InactiveCpInfo
                        result={result}
                        projectUnitPrice={projectUnitPrice}
                        unitDiscount={unitDiscount}
                        purchasable={purchasable}
                        ownCp={ownCp}
                    />
                </>
            }
        }
    }

    return CpInfoContainer;
};

export default RebarCpInfo;
